import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import {
  STATUS_CODE_200,
  SUCCESS,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { CustomLoader } from "../../../../components/main_comps/custom_loader";
import CustomModal from "../../../../components/main_comps/custom_modal";
import OnboardUserIndex from "../../role_management/onboard_user";
import custom_getvalue from "../../../../components/main_comps/custom_getvalue";
import { ESKAY } from "../../../../../data/redux/constants";

const Container = ({ title, value }) => {
  return (
    <div style={{ display: "flex", marginBottom: "20px" }}>
      <p
        style={{
          color: "#000000",
          fontSize: "14px",
          fontWeight: "500",
          width: "180px",
        }}
      >
        {title}
      </p>
      <p style={{ color: "#3A3A3A", fontSize: "14px" }}>{value}</p>
    </div>
  );
};

const AddRemitterModal = ({ onClickCancel, apicall, onChange }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [remitterAccountName, setRemitterAccountName] = useState("");
  const [remitterAccountNumber, setRemitterAccountNumber] = useState("");
  const [remitterAccountIfsc, setRemitterAccountIfsc] = useState("");
  const [accountValidate, setAccountValidate] = useState("");
  const [loading, setLoading] = useState("");
  const [zyroDebitorAcc, setZyroDebitorAcc] = useState(false);
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
    border: "0px",
    marginBottom: 20,
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20,
  };

  const validateAccountWithPennyDrop = () => {
    if (
      !remitterAccountNumber &&
      !remitterAccountIfsc &&
      !remitterAccountName
    ) {
      enqueueSnackbar("Please enter all the account details", {
        variant: "error",
      });
      return;
    }

    if (remitterAccountNumber.length < 9) {
      enqueueSnackbar("Please enter valid account number", {
        variant: "error",
      });
      return;
    }

    if (remitterAccountIfsc.length != 11) {
      enqueueSnackbar("Please enter valid ifsc code", {
        variant: "error",
      });
      return;
    }
    setLoading(true);
    ApiRequestPost.checkPennyDropAccount({
      accNo: remitterAccountNumber,
      ifsc: remitterAccountIfsc,
      benificiaryName: remitterAccountName,
      address: "Banglore",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          if (res?.data?.status === SUCCESS) {
            setAccountValidate(true);

            enqueueSnackbar("Account verified successfully", {
              variant: "success",
            });
          } else {
            let errorMessgae = "Account verification failed";

            if (res?.data?.desc && res?.data?.recommendedAction) {
              errorMessgae =
                res?.data?.desc + ":" + res?.data?.recommendedAction;
            } else if (res?.data?.desc) {
              errorMessgae = res?.data?.desc;
            }
            enqueueSnackbar(errorMessgae, {
              variant: "error",
            });
          }
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    onChange({
      remitterAccountName,
      remitterAccountNumber,
      remitterAccountIfsc,
    });
  }, [remitterAccountName, remitterAccountNumber, remitterAccountIfsc]);
  return (
    <>
      <p
        style={{
          borderBottom: `3px solid ${primaryColor}`,
          marginBottom: 10,
        }}
      >
        Add Account{" "}
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",

          maxWidth: 500,
          minWidth: 300,
        }}
      >
        {" "}
        <CustomInput
          value={remitterAccountName}
          onChange={(e) => setRemitterAccountName(e)}
          placeholder="Name as per the Bank"
          validator={"businessName"}
          inputStyles={{
            ...inputStyle,
          }}
          type="input"
          containerStyles={{
            ...containerStyle,
          }}
        />
        <CustomInput
          value={remitterAccountNumber}
          onChange={(e) => setRemitterAccountNumber(e)}
          type="input"
          placeholder="Bank account Number"
          validator="accountNumber"
          inputStyles={{
            ...inputStyle,
          }}
          containerStyles={{
            ...containerStyle,
          }}
        />
        <CustomInput
          type="input"
          value={remitterAccountIfsc}
          validator="ifscCode"
          onChange={(e) => setRemitterAccountIfsc(e)}
          placeholder="Bank IFSC code"
          inputStyles={{
            ...inputStyle,
          }}
          containerStyles={{
            ...containerStyle,
          }}
        />
        {loading ? (
          <CustomLoader />
        ) : (
          <p
            style={{
              fontSize: 14,
              color: accountValidate ? "#009152" : "#001777",
              cursor: accountValidate ? "not-allowed" : "pointer",
              fontWeight: "500",
              marginTop: "5px",
            }}
            onClick={() => {
              if (!accountValidate) {
                validateAccountWithPennyDrop();
              }
            }}
          >
            {accountValidate ? "Verified" : "Validate"}
          </p>
        )}
        <div
          style={{
            display: "flex",
            gap: 20,
            justifyContent: "center",
          }}
        >
          <CustomButton
            title="Cancel"
            styles={{
              backgroundColor: colorWhite,
              border: "1px solid black",
              padding: 0,
              height: "auto",
              padding: "10px",
            }}
            textStyles={{
              color: colorBlack,
            }}
            onClick={onClickCancel}
          />
          <CustomButton
            title={"Save"}
            styles={{
              backgroundColor: primaryColor,
              border: `1px solid ${primaryColor}`,
              marginLeft: "20px",
            }}
            onClick={() => {
              if (accountValidate) {
                apicall({
                  remitterAccountName,
                  remitterAccountNumber,
                  remitterAccountIfsc,
                });
              } else {
                enqueueSnackbar("Please Validate account", {
                  variant: "error",
                });
              }
            }}
            textStyles={{ color: "white" }}
          />
        </div>
      </div>
    </>
  );
};

const BankAccountDetails = ({
  data,
  isEditClicked = false,
  onChange,
  apicall,
}) => {
  const [nameAsPerBank, setNameAsPerBank] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [remitterAccountName, setRemitterAccountName] = useState("");
  const [remitterAccountNumber, setRemitterAccountNumber] = useState("");
  const [remitterAccountIfsc, setRemitterAccountIfsc] = useState("");
  const [payoutAvailable, setPayoutAvailable] = useState(false);
  const [prefundAccountDetails, setPrefundAccountDetails] = useState("");
  const [onClickAddRemitterAc, setOnClickAddRemitterAc] = useState(false);
  const [accountValidate, setAccountValidate] = useState(false);
  const [settlementAccountValidate, setSettlementAccountValidate] =
    useState(false);
  const [loading, setLoading] = useState("");
  const [settlementLoading, setSettlementLoading] = useState("");
  const [newDebitorAccount, setNewDebitorAccount] = useState([]);
  const [debitorAccNumber, setDebitorAccNumber] = useState("");
  // NEW ONE
  const [corpId, setCorpId] = useState("");

  const { enqueueSnackbar } = useSnackbar();
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    borderRadius: "5px",
    width: "100%",
  };
  const containerStyle = {
    padding: 0,
    maxWidth: 300,
    minWidth: "250px",
    width: "100%",
    height: "40px",
  };

  const debitorAccKeys = {
    corpid: "Corporate Id",
    userid: "User Id",
    debitorAccNumber: "Debitor Account Number",
    debitorAccIfsc: "Debitor IFSC CODE",
    revenueAccNumber: "Revenue Account Number",
    revenueAccIfsc: "Revenue Account IFSC",
  };

  const validateAccountWithPennyDrop = ({
    accNo,
    ifsc,
    name,
    settlement = false,
  }) => {
    if (!accNo && !ifsc && !name) {
      enqueueSnackbar("Please enter all the account details", {
        variant: "error",
      });
      return;
    }

    if (accNo.length < 9) {
      enqueueSnackbar("Please enter valid account number", {
        variant: "error",
      });
      return;
    }

    if (ifsc.length != 11) {
      enqueueSnackbar("Please enter valid ifsc code", {
        variant: "error",
      });
      return;
    }

    if (!name) {
      enqueueSnackbar("Please enter name", {
        variant: "error",
      });
      return;
    }

    settlement ? setSettlementLoading(true) : setLoading(true);

    ApiRequestPost.checkPennyDropAccount({
      accNo: accNo,
      ifsc: ifsc,
      benificiaryName: name,
      address: "Banglore",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          if (res?.data?.status === SUCCESS) {
            if (settlement) {
              setSettlementAccountValidate(true);
            } else {
              setAccountValidate(true);
            }

            enqueueSnackbar("Account verified successfully", {
              variant: "success",
            });
          } else {
            let errorMessgae = "Account verification failed";

            if (res?.data?.desc && res?.data?.recommendedAction) {
              errorMessgae =
                res?.data?.desc + ":" + res?.data?.recommendedAction;
            } else if (res?.data?.desc) {
              errorMessgae = res?.data?.desc;
            }
            enqueueSnackbar(errorMessgae, {
              variant: "error",
            });
          }
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((e) => {})
      .finally(() => {
        setSettlementLoading(false);

        setLoading(false);
      });
  };

  useEffect(() => {
    onChange({
      nameAsPerBank: custom_getvalue(nameAsPerBank, data?.nameAsPerBank),
      accountNumber: custom_getvalue(accountNumber, data?.bankAccountNumber),
      ifscCode: custom_getvalue(ifscCode, data?.bankIfscCode),
      remitterAccountName: custom_getvalue(
        remitterAccountName,
        data?.remitterNameAsPerBank
      ),
      remitterAccountNumber: custom_getvalue(
        remitterAccountNumber,
        data?.remitterAccountNumber
      ),
      remitterAccountIfsc: custom_getvalue(
        remitterAccountIfsc,
        data?.remitterIfscCode
      ),
      settlementAccountValidate,
      accountValidate,
      // corpId: data?.programs[0]?.debitorAcc[0]?.corpid === corpId ? "" : corpId,
    });
  }, [
    nameAsPerBank,
    accountNumber,
    ifscCode,
    remitterAccountName,
    remitterAccountNumber,
    remitterAccountIfsc,
    settlementAccountValidate,
    accountValidate,
    newDebitorAccount,
    corpId,
  ]);

  useEffect(() => {
    if (!isEditClicked) {
      setNameAsPerBank(data?.nameAsPerBank);
      setAccountNumber(data?.bankAccountNumber);
      setIfscCode(data?.bankIfscCode);
      setRemitterAccountName(data?.remitterNameAsPerBank);
      setRemitterAccountNumber(data?.remitterAccountNumber);
      setRemitterAccountIfsc(data?.remitterIfscCode);
      setDebitorAccNumber(data?.debitorAccNumber);
    }
  }, [isEditClicked, data]);

  useEffect(() => {
    if (payoutAvailable) {
      ApiRequestGet.getVanAccount({ id: data?.userId })
        .then((res) => {
          if (res.statusCode === STATUS_CODE_200) {
            setPrefundAccountDetails(res?.data?.vanAccountId);
          }
        })
        .catch((err) => {})
        .finally(() => {});
    }
    const alternatePrefundData = data?.programs.find(
      (item) =>
        item?.mechanism === "van" &&
        (item?.serviceProviderName.toUpperCase() === "AXIS" ||
          item?.serviceProviderName.toUpperCase() === "IDFC") &&
        item?.service_type === "payout"
    );
    if (alternatePrefundData) {
      setPrefundAccountDetails(
        alternatePrefundData.debitorAcc[0].debitorAccNumber
      );
    }
  }, [payoutAvailable]);

  useEffect(() => {
    let payout = data?.service?.filter(
      (obj) =>
        obj.serviceType === "payout" &&
        obj?.serviceProviderName.toUpperCase() !== ESKAY
    );
    if (payout?.length !== 0) {
      setPayoutAvailable(true);
    } else setPayoutAvailable(false);
  }, []);

  useEffect(() => {
    const vanPrograms = data?.programs?.filter(
      (item) =>
        ["cba", "van", "vba"].includes(item?.mechanism) ||
        item?.service_type === "payout"
    );
    if (vanPrograms.length > 0) {
      setPayoutAvailable(true);
    } else {
      setPayoutAvailable(false);
    }

    let temp = [];

    const mergedDebitorAccount = temp.concat(vanPrograms);
    setNewDebitorAccount(mergedDebitorAccount);
    setDebitorAccNumber(mergedDebitorAccount);
  }, [data]);

  return (
    <div style={{ padding: "10px 20px" }}>
      {isEditClicked ? (
        <>
          {data?.remitterAccountNumber && (
            <div>
              <div
                style={{
                  color: primaryColor,
                  fontWeight: "500",
                  textAlign: "center",
                  marginBottom: 20,
                  textAlignLast: "left",
                }}
              >
                Remitter Account
              </div>
              <div style={{ width: "50%", minWidth: "400px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "14px",
                      fontWeight: "500",
                      width: "180px",
                    }}
                  >
                    {"Name:"}
                  </p>
                  <CustomInput
                    value={remitterAccountName}
                    onChange={(data) => setRemitterAccountName(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Name as per bank"
                    validator={"businessName"}
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "14px",
                      fontWeight: "500",
                      width: "180px",
                    }}
                  >
                    {"Bank account Number:"}
                  </p>
                  <CustomInput
                    value={remitterAccountNumber}
                    onChange={(data) => setRemitterAccountNumber(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Bank account number"
                    validator="accountNumber"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "14px",
                      fontWeight: "500",
                      width: "180px",
                    }}
                  >
                    {"Bank IFSC code:"}
                  </p>
                  <CustomInput
                    value={remitterAccountIfsc}
                    onChange={(data) => setRemitterAccountIfsc(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Bank IFSC code"
                    validator="ifscCode"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />

                  {loading ? (
                    <div
                      style={{
                        marginTop: "5px",
                        marginLeft: "10px",
                      }}
                    >
                      <CustomLoader />
                    </div>
                  ) : (
                    <p
                      style={{
                        fontSize: 14,
                        color: accountValidate ? "#009152" : "#001777",
                        cursor: accountValidate ? "not-allowed" : "pointer",
                        fontWeight: "500",
                        marginTop: "5px",
                        marginLeft: "10px",
                      }}
                      onClick={() => {
                        if (!accountValidate) {
                          validateAccountWithPennyDrop({
                            accNo: remitterAccountNumber,
                            ifsc: remitterAccountIfsc,
                            name: remitterAccountName,
                          });
                        }
                      }}
                    >
                      {accountValidate ? "Verified" : "Validate"}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
          <br />
          {data?.nameAsPerBank?.length > 0 &&
            data?.bankAccountNumber?.length > 0 &&
            data?.bankIfscCode?.length > 0 && (
              <div>
                <div
                  style={{
                    color: primaryColor,
                    fontWeight: "500",
                    textAlign: "center",
                    marginBottom: 20,
                    textAlignLast: "left",
                  }}
                >
                  Settlement Account
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "14px",
                      fontWeight: "500",
                      width: "180px",
                    }}
                  >
                    {"Name:"}
                  </p>
                  <CustomInput
                    value={nameAsPerBank}
                    onChange={(data) => setNameAsPerBank(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Name as per bank"
                    validator={"businessName"}
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "14px",
                      fontWeight: "500",
                      width: "180px",
                    }}
                  >
                    {"Bank account Number:"}
                  </p>
                  <CustomInput
                    value={accountNumber}
                    onChange={(data) => setAccountNumber(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Bank account number"
                    validator="accountNumber"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "14px",
                      fontWeight: "500",
                      width: "180px",
                    }}
                  >
                    {"Bank IFSC code:"}
                  </p>
                  <CustomInput
                    value={ifscCode}
                    onChange={(data) => setIfscCode(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Bank IFSC code"
                    validator="ifscCode"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />

                  {settlementLoading ? (
                    <div
                      style={{
                        marginTop: "5px",
                        marginLeft: "10px",
                      }}
                    >
                      <CustomLoader />
                    </div>
                  ) : (
                    <p
                      style={{
                        fontSize: 14,
                        color: settlementAccountValidate
                          ? "#009152"
                          : "#001777",
                        cursor: settlementAccountValidate
                          ? "not-allowed"
                          : "pointer",
                        fontWeight: "500",
                        marginTop: "5px",
                        marginLeft: "10px",
                      }}
                      onClick={() => {
                        if (!settlementAccountValidate) {
                          validateAccountWithPennyDrop({
                            accNo: accountNumber,
                            ifsc: ifscCode,
                            name: nameAsPerBank,
                            settlement: true,
                          });
                        }
                      }}
                    >
                      {settlementAccountValidate ? "Verified" : "Validate"}
                    </p>
                  )}
                </div>
              </div>
            )}
        </>
      ) : data?.remitterAccountNumber ? (
        <>
          <div
            style={{
              color: primaryColor,
              fontWeight: "500",
              textAlign: "center",
              marginBottom: 20,
              textAlignLast: "left",
            }}
          >
            Remitter Account
          </div>
          <Container title="Name:" value={data?.remitterNameAsPerBank} />
          <Container
            title="Bank account Number:"
            value={data?.remitterAccountNumber}
          />
          <Container title="Bank IFSC code:" value={data?.remitterIfscCode} />
          <br />
        </>
      ) : null}
      {/* SETTlEMENT ACCOUNT RENDER */}
      {!isEditClicked &&
        data &&
        data?.nameAsPerBank?.length > 0 &&
        data?.bankAccountNumber?.length > 0 &&
        data?.bankIfscCode?.length > 0 && (
          <div>
            <div
              style={{
                color: primaryColor,
                fontWeight: "500",
                textAlign: "center",
                marginBottom: 20,
                textAlignLast: "left",
              }}
            >
              Settlement Account
            </div>

            <Container title="Name:" value={data?.nameAsPerBank} />
            <Container
              title="Bank account Number:"
              value={data?.bankAccountNumber}
            />
            <Container title="Bank IFSC code:" value={data?.bankIfscCode} />
          </div>
        )}
      {!isEditClicked &&
        newDebitorAccount?.length > 0 &&
        newDebitorAccount.map((item, index) =>
          ["cba", "van", "vba"].includes(item?.mechanism) ||
          (item?.service_type === "payout" && item?.service_type === "van") ? (
            <div key={index}>
              {payoutAvailable && item?.debitorAcc?.length > 0 && (
                <>
                  <div
                    style={{
                      color: primaryColor,
                      fontWeight: "500",
                      textAlign: "center",
                      marginBottom: 20,
                      textAlignLast: "left",
                    }}
                  >
                    {item?.serviceProviderName} Debitor Account
                  </div>
                  <div>
                    {Object.entries(item?.debitorAcc[0]).map(
                      ([key, value], index) => {
                        if (key !== "_id" && key !== "status" && value) {
                          const customKeyName = debitorAccKeys[key] || key;
                          return (
                            <Container
                              key={index}
                              title={customKeyName}
                              value={value}
                            />
                          );
                        }
                      }
                    )}
                  </div>
                </>
              )}

              {item.revenueAcc?.length > 0 && (
                <div>
                  {Object.entries(item?.revenueAcc[0]).map(
                    ([key, value], index) => {
                      if (key !== "_id" && key !== "status" && value) {
                        const customKeyName =
                          key === "revenueAccNumber"
                            ? "Revenue Account Number"
                            : key === "revenueAccIfsc"
                            ? "Revenue Account IFSC"
                            : "";

                        return (
                          <Container
                            key={index}
                            title={customKeyName}
                            value={value}
                          />
                        );
                      }
                    }
                  )}
                </div>
              )}
            </div>
          ) : null
        )}

      {/* PREFUND ACCOUNT */}
      {!isEditClicked && payoutAvailable ? (
        <>
          <div
            style={{
              color: primaryColor,
              fontWeight: "500",
              textAlign: "center",
              margin: "20px 0px",
              textAlignLast: "left",
            }}
          >
            Prefund Account
          </div>
          <Container
            title="Prefund Account Number:"
            value={prefundAccountDetails}
          />
          <Container title="Prefund Account IFSC code:" value={"YESB0CMSNOC"} />
        </>
      ) : null}
      {onClickAddRemitterAc && (
        <CustomModal
          headerTitle=""
          open={onClickAddRemitterAc}
          onClose={() => {
            setOnClickAddRemitterAc(false);
          }}
          containerStyle={{
            width: "400px",
            height: "auto ",
          }}
        >
          <p style={{ textAlign: "center" }}>Add Remitter Account</p>
          <AddRemitterModal
            onClickCancel={() => {
              setOnClickAddRemitterAc(false);
            }}
            apicall={apicall}
            onChange={onChange}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default BankAccountDetails;
